import React from "react";
import { getRoutes } from "./RouteHandler";
import { Dashboard, ManageAccounts, Settings, Tune } from "@mui/icons-material";

const menu = [
    {
        id: 'dashboard',
        label: 'Accueil',
        icon: <Dashboard />,
        children: [
            { id: 'admin_dashboard', label: 'Tableau de bord' },
        ]
    },
    {
        id: 'administrator',
        label: 'Administrateur',
        icon: <Settings />,
        children: [
            { id: 'administrator_user_list', label: 'Utilisateurs' },
            { id: 'administrator_role_list', label: 'Rôles' },
            { id: 'administrator_mail_log_list', label: 'Logs emails' },
            { id: 'administrator_cron_log_list', label: 'Logs cron' },
        ]
    },
    {
        id: 'configuration',
        label: 'Configuration',
        icon: <Tune />,
        children: [
            { id: 'configuration_prestation_group_list', label: 'Groupes de prestations' },
            { id: 'configuration_prestation_list', label: 'Prestations' },
            { id: 'configuration_product_list', label: 'Produits' },
            { id: 'configuration_availability_list', label: 'Disponibilités' },
        ]
    },
    {
        id: 'crm',
        label: 'CRM',
        icon: <ManageAccounts />,
        children: [
            { id: 'crm_customer_list', label: 'Gestion clients' },
            { id: 'crm_appointment_list', label: 'Rendez-vous' },
        ]
    },
];

export const getMenu = () => {
    let routes = getRoutes();
    let menuTmp = [];

    for (let index1 in menu) {
        let children = [];

        for (let index2 in menu[index1].children) {
            if (routes[menu[index1].children[index2].id]) {
                let c = menu[index1].children[index2];
                c.path = routes[menu[index1].children[index2].id].path

                if (c.params) {
                    for (let key in c.params) {
                        if (c.params[key]) {
                            let regEx = new RegExp(':' + key + '[?]?', 'gi');
                            c.path = c.path.replace(regEx, c.params[key]);
                        } else {
                            let regEx = new RegExp('/:' + key + '[?]?', 'gi');
                            c.path = c.path.replace(regEx, '');
                        }
                    }
                }

                children.push(c);
            }
        }

        if (children.length > 0) {
            let m = {
                id: menu[index1].id,
                label: menu[index1].label,
                icon: menu[index1].icon,
            };
            m.children = children;
            menuTmp.push(m);
        }
    }

    return menuTmp;
}
